module.exports = __webpack_public_path__ + "img/relax2.e103d3d4.png";